import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ModalState } from 'kinetic-angular';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ApiService } from '../services/api/api.service';
import { LoggerService } from '../services/logger/logger.service';
import { LeaveConfirmModalState } from '../services/shared/shared-interface';
import { ConfirmLeavePageFactory } from './leave-page-confirm-popup-factory';

@Injectable({
	providedIn: 'root'
})
export class ConfirmLeavePageService
{
	private readonly modalConfirmation$ = new Subject<boolean>();
	private readonly state$: BehaviorSubject<LeaveConfirmModalState> = new BehaviorSubject<LeaveConfirmModalState>(ConfirmLeavePageFactory.buildConfirmLeavePageAEMLabels());
	leaveConfirmModalState: ModalState = ConfirmLeavePageFactory.buildconfirmLeavePageModalState();

	get state(): LeaveConfirmModalState
	{
		return this.state$.value;
	}

	get stateChanged(): Observable<LeaveConfirmModalState> 
	{
		return this.state$.asObservable();
	}

	constructor(
        public apiService: ApiService,
        private readonly loggerService: LoggerService,
        private readonly toastr: ToastrService
	){}

	public updateState(value: LeaveConfirmModalState): void 
	{
		this.state$.next(value);
	}

	public setModalSelectionObservable(confirmLeave: boolean) 
	{
		this.modalConfirmation$.next(confirmLeave);
	}

	public getModalSelectionObservable(): Observable<boolean> 
	{
		return this.modalConfirmation$.asObservable();
	}

	public getConfirmLeavePageAemData(): void 
	{
		this.apiService.getConfirmLeavePageLabels().subscribe({
			next: (res: LeaveConfirmModalState) => 
			{
				if(res) 
				{
					this.state.heading = res.heading;
					this.state.headingSub = res.headingSub;
					this.state.leave = res.leave;
					this.state.stay = res.stay;
					this.state.closeIcon = res.closeIcon;
					this.leaveConfirmModalState.label = this.state.heading;
					this.leaveConfirmModalState.buttons[0].label = this.state.stay; 
					this.leaveConfirmModalState.buttons[1].label = this.state.leave;
				}
			},
			error: (error: HttpErrorResponse) => 
			{
				this.loggerService.log(error.error.message);
				this.toastr.error(error.error.message);
			}
		});
	}

}
